import { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiOutlineCloseCircle } from "react-icons/ai";

import { ModalContainer, ModalButton } from "./modal.style";

const DisplayApeModal = ({ ape, onClose }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if(!!ape) {
      setIsOpen(true);
    }
  }, [ape]);

  const closeModal = () => {
    setIsOpen(false);
    onClose();
  }

  return (
    <ModalContainer show={isOpen} onHide={onClose}>
        <Container className="p-4">
        <div className="d-flex justify-content-end">
              <button className="btn" onClick={closeModal}>
                <span style={{color: "white"}}>x</span>
              </button>
        </div>
          <Row>
            <Col sm={12} md={6}>
              <div><img className="w-100" src={ape.image} alt="mad-apes" /></div>
            </Col>
            <Col sm={12} md={6}>
              <div>
                <span>Mad apes</span>
                <h2>{`#${ape.id}//`}</h2>
              </div>

                <div className="d-flex btn-wrap justify-content-start flex-wrap">
                  {
                  Array.from({length: 9}, (_, i) => i + 1).map((_, i) => (
                      <ModalButton key={i}>
                        <span className="btn-top">Background</span>
                        <span className="btn-btm">Pink</span>
                      </ModalButton>
                  ))
                  }
                </div>
            </Col>
          </Row>
                <div className="d-flex justify-content-end">
                  <button
                   onClick={closeModal}
                   className="btn p-1"><AiOutlineCloseCircle color="#fff" /></button>
                </div>
        </Container>
    </ModalContainer>

  )

}

export default DisplayApeModal;